import React from "react";
import Icon from "sulu-admin-bundle/components/Icon";

const ChangeTeams = ({ sides, eventDetails, setEventDetails, setGoals }) => {
  const home = sides["home"];
  const away = sides["away"];

  const sideSelected = eventDetails?.sideSelected;
  const nameOfSideSelected = sideSelected?.side; // ie either home or away

  return (
    <div
      style={{
        padding: "10px 30px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          borderRadius: "50%",
          backgroundColor: "transparent",
          border: "1px solid black",
          height: 35,
          width: 35,
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: 20,
        }}
      >
        <Icon name="fa-users" />
      </div>
      {eventDetails?.sideSelected && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "90%",
          }}
        >
          <button
            style={{
              border: "2px solid black",
              borderRadius: 5,
              height: 45,
              backgroundColor: eventDetails?.sideSelected?.teamColor,
              fontWeight: "700",
              fontSize: "16px",
              width: "30%",
              marginRight: 30,
            }}
          >
            {eventDetails?.sideSelected?.teamName}
          </button>
            {eventDetails.quarterSelected !== 'SO' &&
            <button
                style={{
                    border: "none",
                    backgroundColor: "transparent",
                    fontSize: "16px",
                }}
                onClick={() => {
                    setEventDetails((data) => ({
                        ...data,
                        sideSelected: null,
                        sideNotSelected: null,
                        playerSelected: null,
                        playerOpponentSelected: null,
                        [nameOfSideSelected]: {
                            ...data[nameOfSideSelected],
                            goals:
                                data?.type?.name === "GOAL"
                                    ? data[nameOfSideSelected]?.goals - 1
                                    : data[nameOfSideSelected]?.goals,
                        },
                    }));
                }}
            >
                X
                <span
                    style={{
                        border: "none",
                        backgroundColor: "transparent",
                        fontSize: "16px",
                        textDecoration: "underline",
                        marginLeft: 5,
                    }}
                >
                    Ändern
                </span>
            </button>
            }
        </div>
      )}

      {!eventDetails?.sideSelected && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "50%",
          }}
        >
          <button
            style={{
              border: "2px solid black",
              borderRadius: 5,
              height: 45,
              backgroundColor: home?.teamColor,
              fontWeight: "700",
              fontSize: "16px",
              width: "50%",
              marginRight: 20,
            }}
            onClick={() => {
              setEventDetails((data) => ({
                ...data,
                sideSelected: home,
                sideNotSelected: away,
                home: {
                  ...data["home"],
                  goals:
                    data?.type?.name === "GOAL"
                      ? data["home"]?.goals + 1
                      : data["home"]?.goals,
                },
              }));
            }}
          >
            {home?.teamName}
          </button>
          <button
            style={{
              border: "2px solid black",
              borderRadius: 5,
              height: 45,
              backgroundColor: away?.teamColor,
              fontWeight: "700",
              fontSize: "16px",
              width: "50%",
            }}
            onClick={() => {
              setEventDetails((data) => ({
                ...data,
                sideSelected: away,
                sideNotSelected: home,
                away: {
                  ...data["away"],
                  goals:
                    data?.type?.name === "GOAL"
                      ? data["away"]?.goals + 1
                      : data["away"]?.goals,
                },
              }));
            }}
          >
            {away?.teamName}
          </button>
        </div>
      )}
    </div>
  );
};

export default ChangeTeams;
